'use client';

import { c as _c } from "react/compiler-runtime";
import { Alert, AlertDescription, AlertTitle } from '@achra/ui/alert';
import { Button } from '@achra/ui/button';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@achra/ui/form';
import { Input } from '@achra/ui/input';
import { cn } from '@achra/ui/lib/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { Loader2 } from 'lucide-react';
import { startTransition, useActionState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { notifyMeAction } from '@/modules/networks/actions/notify-me-action';
import { formDefaultValues, initialActionState, notifyMeSchema } from '@/modules/networks/lib/notify-me-schema';
import type { NotifyMeFormValues } from '@/modules/networks/types';
interface NotifyMeForm {
  className?: string;
}
function NotifyMeForm(t0) {
  const $ = _c(34);
  const {
    className
  } = t0;
  const [state, formAction, isPending] = useActionState(notifyMeAction, initialActionState);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(notifyMeSchema),
      defaultValues: formDefaultValues
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  let t2;
  if ($[1] !== form || $[2] !== state.error) {
    t2 = () => {
      if (state.error) {
        form.setError("email", {
          type: "server",
          message: state.error
        });
      }
    };
    $[1] = form;
    $[2] = state.error;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== form || $[5] !== state) {
    t3 = [state, form];
    $[4] = form;
    $[5] = state;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function onSubmit(data) {
      const formData = new FormData();
      formData.append("email", data.email);
      startTransition(() => {
        formAction(formData);
      });
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onSubmit = t4;
  if (state.success) {
    let t5;
    if ($[8] !== className) {
      t5 = cn("w-full", className);
      $[8] = className;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <AlertTitle>You are on the list</AlertTitle>;
      t7 = <AlertDescription>We will email you when new networks are added to Achra.</AlertDescription>;
      $[10] = t6;
      $[11] = t7;
    } else {
      t6 = $[10];
      t7 = $[11];
    }
    let t8;
    if ($[12] !== t5) {
      t8 = <Alert variant="default" role="status" className={t5}>{t6}{t7}</Alert>;
      $[12] = t5;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    return t8;
  }
  let t5;
  if ($[14] !== form) {
    t5 = event => {
      event.preventDefault();
      form.handleSubmit(onSubmit)(event);
    };
    $[14] = form;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== className) {
    t6 = cn("flex w-full flex-col items-center gap-2.5 sm:flex-row", className);
    $[16] = className;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== form.control || $[19] !== isPending) {
    t7 = <FormField control={form.control} name="email" disabled={isPending} render={_temp} />;
    $[18] = form.control;
    $[19] = isPending;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== isPending) {
    t8 = isPending ? <><Loader2 className="size-4 animate-spin" aria-hidden="true" />Notifying</> : <>Notify Me</>;
    $[21] = isPending;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isPending || $[24] !== t8) {
    t9 = <Button type="submit" className="w-full sm:w-fit" disabled={isPending}>{t8}</Button>;
    $[23] = isPending;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7 || $[29] !== t9) {
    t10 = <form noValidate={true} onSubmit={t5} className={t6}>{t7}{t9}</form>;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== form || $[32] !== t10) {
    t11 = <Form {...form}>{t10}</Form>;
    $[31] = form;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem className="bg-input h-9 w-full rounded-md sm:max-w-74"><FormControl><Input {...field} type="email" placeholder="Your email address" autoComplete="email" /></FormControl><FormMessage className="text-primary-foreground" /></FormItem>;
}
export { NotifyMeForm };